// GIS has one global credential callback. Route it to the button actually clicked.
const clients = new WeakMap();
let nextSession=0;
function createGoogleButtonSession(id, clientId, onCredential) {
 let state = clients.get(id);
 if (!state) {
  state = { active: null, clientId, sessions:new Map() };
  id.initialize({client_id: clientId, auto_select: false, callback(response) {
   const selected=response?.state ? state.sessions.get(response.state) : state.active;
   if(selected===state.active)state.active=null;
   if(selected?.live&&response?.credential)selected.receive(response.credential);
  }});
  clients.set(id,state);
 }
 if(state.clientId!==clientId)throw Error('Google istemci ayarı uyuşmuyor.');
 const key=`kelimo-google-${++nextSession}`;
 const session={live:true,receive:onCredential};state.sessions.set(key,session);
 return {state:key,activate(){if(session.live)state.active=session;},dispose(){session.live=false;state.sessions.delete(key);if(state.active===session)state.active=null;}};
}
module.exports={createGoogleButtonSession};
